import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import { ReactComponent as ArrowNextIcon } from '@svgs/keyline/arrow-next.svg'
import { getLink } from '@helpers/env'
import styles from './styles.module.scss'

export type FlashBannerLinkProps = {
  linkUrl: string | null
  linkTextDesktop: string | null
}

function FlashBannerLink({ linkUrl, linkTextDesktop }: FlashBannerLinkProps) {
  const isPhabletUp = useMediaQuery({ minWidth: BREAKPOINT_SIZES.PHABLET })

  if (!linkUrl || !linkTextDesktop) {
    return null
  }

  return (
    <div className={styles.flashLinkWrapper}>
      {isPhabletUp ? (
        <a className={styles.flashLink} href={getLink(linkUrl)}>
          {linkTextDesktop}
        </a>
      ) : (
        <div className={styles.flashLink__icon}>
          <ArrowNextIcon fill="currentColor" />
        </div>
      )}
    </div>
  )
}

export default FlashBannerLink
